import { isRecord } from '#layers/base/utils/object';

function asStatusCode(value: unknown): number | undefined {
	return typeof value === 'number' ? value : undefined;
}

export function getErrorStatusCode(error: unknown): number | undefined {
	if (!isRecord(error)) return undefined;

	return asStatusCode(error.statusCode)
		?? asStatusCode(error.status)
		?? (isRecord(error.response) ? asStatusCode(error.response.status) : undefined);
}
